<template>
    <modal closeMutation="SET_SHOP_ITEM_SERVICE_MODAL">
        <div class="modal_shop_item-header">
            <div v-if="item.badge !== undefined"
                 class="modal_shop_item-badge shop_item-badge"
                 :class="'badge-'+item.badge.color"
            >
                {{this.item.badge.text}}
            </div>
            <div class="modal_shop_item-name">
                {{item.name}}
            </div>
        </div>
        <div class="modal_shop_item-description">
            {{item.description}}
        </div>
        <div class="modal_shop_item-schedules" v-if="item.schedule_template !== null">
            <div class="modal_shop_item-schedules_item"
                 v-for="schedule in item.schedule_template" :key="schedule.id">
                {{schedule.name}}
            </div>
        </div>
        <div class="modal_shop_item-data">
            <div class="modal_shop_item-data--row">
                <div class="key">
                    Посещений
                </div>
                <div class="value">
                    {{this.visits}}
                </div>
            </div>
            <div class="modal_shop_item-data--row">
                <div class="key">
                    Срок действия
                </div>
                <div class="value">
                    {{this.duration}}
                </div>
            </div>
        </div>
        <div class="modal_shop_item-btn btn btn-square" @click="this.$store.commit('SET_SHOP_PAYMENT_MODAL', {'item_type': 'service', 'data': this.item})">
            <div class="modal_shop_item-btn--text">
                Оплатить
            </div>
            <div class="modal_shop_item-btn--price">
                <div class="modal_shop_item-btn--price-old" v-if="priceSale != null && priceSale.value !== priceFull.value">
                    <currency-symbol :price="priceFull"/>
                </div>
                <div class="modal_shop_item-btn--price-new">
                    <currency-symbol :price="price"/>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import Modal from "../../views/Modal";
    import {plural} from "../../utilities";
    import CurrencySymbol from "../CurrencySymbol";
    export default {
        name: "ShopModalService",
        components: {CurrencySymbol, Modal},
        props: {
            item: {},
        },
        computed: {
            price: function () {
                return !this.priceSale ? this.item.price_full : this.priceSale
            },
            priceSale: function () {
                return this.item.sale_price ? this.item.sale_price : null
            },
            priceFull: function () {
                return this.item.price_full
            },
            visits() {
                return this.item.count !== null ? plural(this.item.count, ['посещение', 'посещения', 'посещений']) : ''
            },
            duration() {
                return this.item.validity_period !== null ? plural(this.item.validity_period, ['день', 'дня', 'дней']) : ''
            },
        }
    }
</script>